import React from 'react'
import moment from "moment/moment";
import Typography from '@material-ui/core/Typography'
import { FlexDataItem } from 'components/FlexDataView'
import { DateTimeDisplay } from 'components'
import DateIcon from '@material-ui/icons/DateRange'
import {FormattedMessage} from 'react-intl'

export default props =>
  <FlexDataItem className={props.className}>
    <Typography variant='subtitle1'>
      <DateIcon />
      <FormattedMessage
        id={`allocation.section.date.${moment(props.allocation.startDate) > moment(Date.now()) ? 'upcoming_title' : 'current_title'}`}
      />
    </Typography>
    {/*if*/ moment(props.allocation.startDate) > moment(Date.now()) ?
      <dl>
        <dt><FormattedMessage id="allocation.section.date.start_on_label" /></dt>
        <dd><DateTimeDisplay value={props.allocation.startDate} singleLine/></dd>
      </dl>
      /*else if*/: moment(props.allocation.endDate) > moment(Date.now()) ?
        <dl>
          <dt><FormattedMessage id="allocation.section.date.end_on_label.future" /></dt>
          <dd><DateTimeDisplay value={props.allocation.endDate} singleLine/></dd>
        </dl>
        /*else*/:
        <dl>
          <dt><FormattedMessage id="allocation.section.date.end_on_label.past" /></dt>
          <dd><DateTimeDisplay value={props.allocation.endDate} singleLine/></dd>
        </dl>
    }
  </FlexDataItem>